import { combineReducers } from "@reduxjs/toolkit";
import userSlices from "./slices/userSlices";
import newRoleSlices from "./slices/newRoleSlices";
import careersSlices from "./slices/careersSlices.reducer";

export const rootReducer = combineReducers({
    user: userSlices,
    newRole: newRoleSlices,
    careers: careersSlices
});